import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import TopClinicalTrialsWrapper from "@components/layouts/topClinicalTrialsWrapper";

export default function TopClinicalTrialsHome(): ReactElement {
    return (
        <TopClinicalTrialsWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#194070" />
                </div>
                <FormSection iconsFillColor="#194070" />
            </div>
        </TopClinicalTrialsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
